import React from "react";
import Body from "../Body/Body";


const Home = () => {
  return (
    <>
      <Body />
      
    </>
  );
};

export default Home;
